import './PlanityScreen.css'

/**
 * Contenu affiché dans l'écran du PhoneMockup : l'étape « choix de la prestation »
 * du parcours de réservation, tel qu'il apparaît sur /reserver-en-ligne.
 *
 * Reconstitution, pas capture — d'où la légende explicite portée par le PhoneMockup.
 *
 * TODO(lot 4 back-office): lire le catalogue au lieu de recopier des montants.
 * Ces quatre lignes sont une copie manuelle des tarifs de l'institut, et une copie
 * manuelle dérive — c'est déjà arrivé : le balinais annonçait 75,00 € (tarif
 * adhérent) sans le dire, quand le gommage annonçait 40,00 € (tarif sans pass).
 * Deux conventions opposées sur deux lignes voisines. Quand la branche catalogue
 * sera fusionnée, remplacer PRESTATIONS par useCatalog() et le champ `detail` par
 * <ServicePrice amounts={...} /> (src/hooks/useCatalog.js et
 * src/pages/Services/ServicePrice.jsx). Deux points de vigilance à ce moment-là :
 * vérifier que les quatre cartes tiennent toujours dans l'écran de 599 px
 * (cf. PlanityScreen.css), et noter que le balinais est un tarif `duo` — la ligne
 * ci-dessous omet le prix à deux (145,00 €), faute de place ; ServicePrice, lui,
 * l'affiche.
 *
 * La source de vérité est désormais la base de données du catalogue, alimentée par
 * la migration du lot catalogue depuis
 * packages/api/src/scripts/catalogImport/services.source.json (fixture historique,
 * conservée pour son contrôle de non-régression) — d'où l'absence de chemin figé
 * ici.
 *
 * En attendant, une seule convention, celle de ServicePrice : un tarif à deux
 * niveaux montre les DEUX montants en nommant lequel est lequel, et un tarif
 * dégressif annonce le prix plein (le plus élevé) et signale la dégressivité —
 * jamais « à partir de », qui suggérerait que 28,00 € est un plancher alors que
 * c'est le tarif d'une personne seule et qu'il descend jusqu'à 17,00 €.
 */
const PRESTATIONS = [
  { name: 'Hammam — savon noir offert', detail: '45 min · 28,00 € / pers., dégressif à plusieurs' },
  { name: "Hammam + SPA (Bulle d'Ô)", detail: '60 min · 44,00 € / pers., dégressif à plusieurs' },
  { name: 'Soin balinais', detail: '60 min · 75,00 € avec le pass, 80,00 € sans' },
  { name: 'Gommage Baïja — Moana', detail: '30 min · 35,00 € avec le pass, 40,00 € sans' },
]

function PlanityScreen() {
  return (
    <div className="planity-screen">
      <div className="planity-screen-header">
        <div className="planity-screen-name">Azoya Spa</div>
        <div className="planity-screen-location">Auxerre · Institut &amp; Spa</div>
      </div>

      <div className="planity-screen-steps">
        <span className="planity-screen-step planity-screen-step--active">1 Prestation</span>
        <span className="planity-screen-step-line" />
        <span className="planity-screen-step">2 Praticienne</span>
        <span className="planity-screen-step-line" />
        <span className="planity-screen-step">3 Créneau</span>
      </div>

      <div className="planity-screen-title">Choisissez votre prestation</div>
      <div className="planity-screen-category">Spa · Hammam</div>

      <div className="planity-screen-list">
        {PRESTATIONS.map((prestation) => (
          <div className="planity-screen-item" key={prestation.name}>
            <div className="planity-screen-item-text">
              <div className="planity-screen-item-name">{prestation.name}</div>
              <div className="planity-screen-item-detail">{prestation.detail}</div>
            </div>
            <span className="planity-screen-item-cta">Choisir</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PlanityScreen
